import { Expose, Type } from 'class-transformer';
import { AttachmentTypeEnum } from '@/enums/crm/attachment-type.enum';

export default class AttachmentModel {
  id!: number;

  clientId!: string;

  path!: string;

  src!: string;

  name!: string;

  description!: string;

  type!: AttachmentTypeEnum;

  @Type(() => Date)
  creationDate!: Date;

  @Expose({ name: 'usuarioInclusao' })
  creationUser!: string;

  @Expose({ name: 'usuarioInclusaoId' })
  creationUserId!: number;

  @Expose({ name: 'idProcesso' })
  processId!: number;

  @Expose({ name: 'idFluxo' })
  flowId!: number;

  @Expose({ name: 'idFila' })
  queueId!: number;

  @Expose({ name: 'nomeFluxo' })
  flowName!: string;

  @Expose({ name: 'tipoCliente' })
  clientType!: string;
}
